export const translations = {
  pl: {
    nav: { home: "Start", shop: "Sklep", drop: "Drop", cart: "Koszyk" },
    home: {
      heroTag: "SlimeGlass // Wielorazowe szklane filtry",
      headline: ["JESZCZE NIGDY", "NIE PALIŁEŚ", "W TEN SPOSÓB"],
      heroCta: "Kup z dropu",
      heroSub: "Wielorazowe szklane filtry 12 mm. Kobaltowy błękit i neonowy pomarańcz. Limitowany Drop 02.",
      manifesto1: "Więcej niż filtr.",
      manifesto2: "Ruch.",
      chapters: [
        { t: "Szkło zamiast papieru", d: "Kartonowe filtry rozmiękają, zapadają się i nie mają smaku. Nasze są z litego szkła — chłodne, czyste i wielokrotnego użytku." },
        { t: "Zanurzone w slime", d: "Każdy filtr nosi znak SlimeGlass. Krwistoczerwony marmur albo głęboka czerń. To nowy sposób palenia — i ma tak wyglądać." },
        { t: "Stworzone, by trwać", d: "Wypłucz, zatrzymaj, pochwal się. Jeden filtr przeżyje sto paczek. Lepiej dla sesji, dla portfela i dla planety." },
      ],
      availableNow: "Dostępne teraz",
      theDrop: "Drop",
      viewAll: "Zobacz wszystko",
      ctaTitle1: "Zgarnij swój",
      ctaTitle2: "filtr",
      enterShop: "Wejdź do sklepu",
      marquee1: "JAKOŚĆ > WSZYSTKO",
      marquee2a: "PAL W NOWY SPOSÓB",
      marquee2b: "PAL INACZEJ",
    },
    lookbook: {
      tag: "W akcji",
      title: "OUR LIFESTYLE",
      est: "// EST. Warszawa",
      card1: "Zapakowane w slime",
      card1sub: "Zapakowane · oklejone · wysłane",
      card2: "Ekipa niebiesko-pomarańczowa",
      card2sub: "Zatwierdzone przez setup",
    },
    shop: {
      meta: "{n} sztuk · Limitowane serie",
      title: "Sklep",
      marquee: "SLIMEGLASS EXCLUSIVE",
    },
    product: {
      notFound: "Nie znaleziono",
      backToShop: "Powrót do sklepu",
      back: "Wróć",
      onlyLeft: "Zostało tylko {n}",
      addToBag: "Dodaj do torby",
      readMore: "Czytaj więcej",
      readLess: "Zwiń",
      addedToBag: "{name} ×{qty} dodano do torby",
      specs: {
        airflow: "Przepływ powietrza",
        airflowVal: "Spirala 9-otworowa",
        width: "Szerokość",
        length: "Długość",
        lengthVal: "35mm",
        material: "Materiał",
        materialVal: "Szkło borokrzemowe",
      },
    },
    card: { onlyLeft: "Zostało tylko {n}", add: "Dodaj +", added: "{name} dodano do torby" },
    footer: {
      desc: "Wielorazowe szklane filtry dla zupełnie nowego sposobu palenia. Ręcznie wykańczane, stworzone by trwać, zanurzone w slime.",
      shop: "Sklep",
      allTips: "Wszystkie filtry",
      follow: "Obserwuj",
      rights: "Wszelkie prawa zastrzeżone.",
      age: "Tylko 21+ · Używaj odpowiedzialnie",
    },
    cart: {
      title: "Twoja torba",
      empty: "Torba jest pusta",
      emptySub: "Zgarnij jakiś filtr",
      subtotal: "Suma częściowa",
      redirecting: "Przekierowanie…",
      checkout: "Do kasy",
      secure: "Bezpieczna płatność przez Shopify",
      error: "Nie udało się rozpocząć płatności. Spróbuj ponownie.",
    },
    drop: {
      release: "Drop 02 · Limitowana edycja",
      liveTitle1: "Drop jest",
      liveTitle2: "live",
      shopTheDrop: "Powijaj drop",
      landsIn: "Drop startuje za",
      units: { days: "Dni", hours: "Godz.", minutes: "Min.", seconds: "Sek." },
      dateLine: "14/10/2026 · 15:00 · czasu warszawskiego",
      yourTime: "Twojego czasu",
      onList: "Jesteś na liście",
      notifyMe: "Powiadom mnie",
      firstAccess: "Zyskaj pierwszy dostęp, gdy drop wystartuje",
      preview: "Zobacz filtry",
      invalidEmail: "Podaj poprawny email",
      subscribed: "Jesteś na liście — damy znać, gdy wystartuje",
      genericError: "Coś poszło nie tak. Spróbuj ponownie.",
    },
  },
  en: {
    nav: { home: "Home", shop: "Shop", drop: "Drop", cart: "Cart" },
    home: {
      heroTag: "SlimeGlass // Reusable Glass Tips",
      headline: ["YOU HAVEN'T", "SMOKED THIS", "WAY BEFORE"],
      heroCta: "Shop the drop",
      heroSub: "Reusable 12mm glass filter tips. Cobalt blue & neon orange. Limited Drop 02.",
      manifesto1: "More than a tip.",
      manifesto2: "A movement.",
      chapters: [
        { t: "Glass over paper", d: "Cardboard tips go soggy, collapse and taste like nothing. Ours are solid glass — cool, clean, and reusable a thousand times over." },
        { t: "Dripped in slime", d: "Every tip carries the SlimeGlass mark. Deep-red marble or blacked-out gloss. This is a new way to smoke — and it should look the part." },
        { t: "Built to last", d: "Rinse it, keep it, flex it. One tip outlives a hundred packs. Better for your session, better for your pocket, better for the planet." },
      ],
      availableNow: "Available now",
      theDrop: "The Drop",
      viewAll: "View all",
      ctaTitle1: "Cop your",
      ctaTitle2: "tip",
      enterShop: "Enter the shop",
      marquee1: "QUALITY > EVERYTHING",
      marquee2a: "SMOKE A NEW WAY",
      marquee2b: "SMOKE A DIFF WAY",
    },
    lookbook: {
      tag: "In the wild",
      title: "OUR LIFESTYLE",
      est: "// EST. Warszawa",
      card1: "Packed with slime",
      card1sub: "Boxed · stickered · shipped",
      card2: "Blue & orange gang",
      card2sub: "Battlestation approved",
    },
    shop: {
      meta: "{n} pieces · Limited runs",
      title: "The Shop",
      marquee: "SLIMEGLASS EXCLUSIVE",
    },
    product: {
      notFound: "Not found",
      backToShop: "Back to shop",
      back: "Back",
      onlyLeft: "Only {n} left",
      addToBag: "Add to bag",
      readMore: "Read more",
      readLess: "Show less",
      addedToBag: "{name} ×{qty} added to bag",
      specs: {
        airflow: "Airflow",
        airflowVal: "9-hole spiral",
        width: "Width",
        length: "Length",
        lengthVal: "35mm",
        material: "Material",
        materialVal: "Borosilicate glass",
      },
    },
    card: { onlyLeft: "Only {n} left", add: "Add +", added: "{name} added to bag" },
    footer: {
      desc: "Reusable glass filter tips for a whole new way to smoke. Hand-finished, built to last, dripped in slime.",
      shop: "Shop",
      allTips: "All Tips",
      follow: "Follow",
      rights: "All rights reserved.",
      age: "21+ only · Use responsibly",
    },
    cart: {
      title: "Your Bag",
      empty: "Bag's empty",
      emptySub: "Go cop a tip",
      subtotal: "Subtotal",
      redirecting: "Redirecting…",
      checkout: "Checkout",
      secure: "Secure checkout via Shopify",
      error: "Could not start checkout. Try again.",
    },
    drop: {
      release: "Drop 02 · Limited release",
      liveTitle1: "The drop is",
      liveTitle2: "live",
      shopTheDrop: "Shop the drop",
      landsIn: "The drop lands in",
      units: { days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds" },
      dateLine: "14/10/2026 · 15:00 · Warsaw time",
      yourTime: "your time",
      onList: "You're on the list",
      notifyMe: "Notify me",
      firstAccess: "Get first access when the drop goes live",
      preview: "Preview the tips",
      invalidEmail: "Enter a valid email",
      subscribed: "You're on the list — we'll hit you when it drops",
      genericError: "Something went wrong. Try again.",
    },
  },
  cs: {
    nav: { home: "Domů", shop: "Obchod", drop: "Drop", cart: "Košík" },
    home: {
      heroTag: "SlimeGlass // Znovupoužitelné skleněné filtry",
      headline: ["TAKHLE JSI", "JEŠTĚ NIKDY", "NEHULIL"],
      heroCta: "Nakup drop",
      heroSub: "Znovupoužitelné skleněné filtry 12 mm. Kobaltová modrá a neonová oranžová. Limitovaný Drop 02.",
      manifesto1: "Víc než filtr,",
      manifesto2: "kultura.",
      chapters: [
        { t: "Sklo místo papíru", d: "Kartonové filtry rozmoknou, zhroutí se a nemají chuť. Naše jsou z masivního skla — chladivé, čisté a použitelné tisíckrát." },
        { t: "Namočené ve slime", d: "Každý filtr nese značku SlimeGlass. Krvavě rudý mramor nebo černý lesk. Tohle je nový způsob hulení — a má tak i vypadat." },
        { t: "Vyrobené, aby vydržely", d: "Opláchni, nech si, chlub se. Jeden filtr přežije sto balíčků. Lepší pro sezení, pro peněženku i pro planetu." },
      ],
      availableNow: "Dostupné teď",
      theDrop: "Drop",
      viewAll: "Zobrazit vše",
      ctaTitle1: "Pořiď si svůj",
      ctaTitle2: "filtr",
      enterShop: "Vstup do obchodu",
      marquee1: "KVALITA > VŠECHNO",
      marquee2a: "HUL NOVĚ",
      marquee2b: "HUL JINAK",
    },
    lookbook: {
      tag: "V akci",
      title: "OUR LIFESTYLE",
      est: "// EST. Warszawa",
      card1: "Zabaleno ve slime",
      card1sub: "Zabaleno · polepeno · odesláno",
      card2: "Parta modro-oranžová",
      card2sub: "Schváleno setupem",
    },
    shop: {
      meta: "{n} kusů · Limitované série",
      title: "Obchod",
      marquee: "SLIMEGLASS EXCLUSIVE",
    },
    product: {
      notFound: "Nenalezeno",
      backToShop: "Zpět do obchodu",
      back: "Zpět",
      onlyLeft: "Zbývá jen {n}",
      addToBag: "Přidat do košíku",
      readMore: "Číst více",
      readLess: "Sbalit",
      addedToBag: "{name} ×{qty} přidáno do košíku",
      specs: {
        airflow: "Proudění vzduchu",
        airflowVal: "9-otvorová spirála",
        width: "Šířka",
        length: "Délka",
        lengthVal: "35mm",
        material: "Materiál",
        materialVal: "Borosilikátové sklo",
      },
    },
    card: { onlyLeft: "Zbývá jen {n}", add: "Přidat +", added: "{name} přidáno do košíku" },
    footer: {
      desc: "Znovupoužitelné skleněné filtry pro úplně nový způsob hulení. Ručně dokončené, vyrobené aby vydržely, namočené ve slime.",
      shop: "Obchod",
      allTips: "Všechny filtry",
      follow: "Sledujte",
      rights: "Všechna práva vyhrazena.",
      age: "Jen 21+ · Užívejte zodpovědně",
    },
    cart: {
      title: "Tvůj košík",
      empty: "Košík je prázdný",
      emptySub: "Pořiď si filtr",
      subtotal: "Mezisoučet",
      redirecting: "Přesměrování…",
      checkout: "K pokladně",
      secure: "Bezpečná platba přes Shopify",
      error: "Platbu se nepodařilo spustit. Zkus to znovu.",
    },
    drop: {
      release: "Drop 02 · Limitovaná edice",
      liveTitle1: "Drop je",
      liveTitle2: "live",
      shopTheDrop: "Nakup drop",
      landsIn: "Drop startuje za",
      units: { days: "Dny", hours: "Hod.", minutes: "Min.", seconds: "Sek." },
      dateLine: "14/10/2026 · 15:00 · varšavského času",
      yourTime: "vašeho času",
      onList: "Jsi na seznamu",
      notifyMe: "Upozorni mě",
      firstAccess: "Získej první přístup, až drop odstartuje",
      preview: "Prohlédni si filtry",
      invalidEmail: "Zadej platný email",
      subscribed: "Jsi na seznamu — dáme vědět, až to odstartuje",
      genericError: "Něco se pokazilo. Zkus to znovu.",
    },
  },
  de: {
    nav: { home: "Start", shop: "Shop", drop: "Drop", cart: "Warenkorb" },
    home: {
      heroTag: "SlimeGlass // Wiederverwendbare Glasfilter",
      headline: ["SO HAST DU", "NOCH NIE", "GERAUCHT"],
      heroCta: "Shop den Drop",
      heroSub: "Wiederverwendbare 12-mm-Glasfilter. Kobaltblau & Neonorange. Limitierter Drop 02.",
      manifesto1: "Mehr als ein Filter,",
      manifesto2: "Kultur.",
      chapters: [
        { t: "Glas statt Papier", d: "Pappfilter weichen auf, kollabieren und schmecken nach nichts. Unsere sind aus massivem Glas — kühl, sauber und tausendfach wiederverwendbar." },
        { t: "In Slime getaucht", d: "Jeder Filter trägt das SlimeGlass-Zeichen. Blutroter Marmor oder tiefes Schwarz. Das ist eine neue Art zu rauchen — und sie soll auch so aussehen." },
        { t: "Gebaut, um zu halten", d: "Ausspülen, behalten, zeigen. Ein Filter überlebt hundert Packungen. Besser für deine Session, deinen Geldbeutel und den Planeten." },
      ],
      availableNow: "Jetzt verfügbar",
      theDrop: "Der Drop",
      viewAll: "Alle ansehen",
      ctaTitle1: "Schnapp dir deinen",
      ctaTitle2: "Filter",
      enterShop: "Zum Shop",
      marquee1: "QUALITÄT > ALLES",
      marquee2a: "RAUCH NEU",
      marquee2b: "RAUCH ANDERS",
    },
    lookbook: {
      tag: "In freier Wildbahn",
      title: "OUR LIFESTYLE",
      est: "// EST. Warszawa",
      card1: "Verpackt mit Slime",
      card1sub: "Verpackt · beklebt · versandt",
      card2: "Blau-Orange-Gang",
      card2sub: "Battlestation-approved",
    },
    shop: {
      meta: "{n} Stück · Limitierte Auflagen",
      title: "Der Shop",
      marquee: "SLIMEGLASS EXCLUSIVE",
    },
    product: {
      notFound: "Nicht gefunden",
      backToShop: "Zurück zum Shop",
      back: "Zurück",
      onlyLeft: "Nur noch {n}",
      addToBag: "In den Warenkorb",
      readMore: "Mehr lesen",
      readLess: "Weniger anzeigen",
      addedToBag: "{name} ×{qty} zum Warenkorb hinzugefügt",
      specs: {
        airflow: "Luftstrom",
        airflowVal: "9-Loch-Spirale",
        width: "Breite",
        length: "Länge",
        lengthVal: "35mm",
        material: "Material",
        materialVal: "Borosilikatglas",
      },
    },
    card: { onlyLeft: "Nur noch {n}", add: "Hinzu +", added: "{name} zum Warenkorb hinzugefügt" },
    footer: {
      desc: "Wiederverwendbare Glasfilter für eine ganz neue Art zu rauchen. Handgefertigt, gebaut um zu halten, getaucht in Slime.",
      shop: "Shop",
      allTips: "Alle Filter",
      follow: "Folgen",
      rights: "Alle Rechte vorbehalten.",
      age: "Nur 21+ · Verantwortungsvoll genießen",
    },
    cart: {
      title: "Dein Warenkorb",
      empty: "Warenkorb ist leer",
      emptySub: "Schnapp dir einen Filter",
      subtotal: "Zwischensumme",
      redirecting: "Weiterleitung…",
      checkout: "Zur Kasse",
      secure: "Sichere Zahlung über Shopify",
      error: "Zahlung konnte nicht gestartet werden. Versuch es erneut.",
    },
    drop: {
      release: "Drop 02 · Limitierte Edition",
      liveTitle1: "Der Drop ist",
      liveTitle2: "live",
      shopTheDrop: "Shop den Drop",
      landsIn: "Der Drop startet in",
      units: { days: "Tage", hours: "Std.", minutes: "Min.", seconds: "Sek." },
      dateLine: "14/10/2026 · 15:00 · Warschauer Zeit",
      yourTime: "deiner Zeit",
      onList: "Du bist auf der Liste",
      notifyMe: "Benachrichtigen",
      firstAccess: "Sichere dir den ersten Zugang, wenn der Drop live geht",
      preview: "Filter ansehen",
      invalidEmail: "Gib eine gültige E-Mail ein",
      subscribed: "Du bist auf der Liste — wir melden uns beim Drop",
      genericError: "Etwas ist schiefgelaufen. Versuch es erneut.",
    },
  },
};

export function resolve(dict, path) {
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), dict);
}

export function interpolate(str, vars) {
  if (typeof str !== "string" || !vars) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : `{${k}}`));
}
